export default "__VITE_ASSET__Dr8SWEGB__"